// removed by extract-text-webpack-plugin
module.exports = {"actions-wrapper":"actions-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContractCenter/actions/Actions.scss
// module id = 5184
// module chunks = 1